import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { useEffect } from "react";

const Redirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const { auth } = useAuthStore();
  useEffect(() => {
    if (!!searchParams.get("token")) {
      auth.setAccessToken(searchParams.get("token"));
    }
    navigate("/");
  }, [searchParams.get("token")]);
  return <></>;
};

export default Redirect;
